import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar'; 
import {timesheetreportService} from '../../services/timesheetreportsService';
// import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../../helpers/dateformatter';
import {loader} from '../../compnents/loadermd';
import {dataExporthelper} from '../../helpers/exporthelper';
import { Toast } from 'primereact/toast';

const Rdsreports = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        manager: '',
        managername: '',
        employee: 'ALL',
        
      });
    const [loadercomp,setloadecomp] = useState(null);  
    const [datacomp,setDatacomp] = useState([]); 
    const [manager,setmanger] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [isloaded,setloaded] = useState(true); 
    const [managerscomp,setmanagercomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [currentuser,setUser] = useState(''); 
    const [break_time,setBreaktime] = useState('');
    const [rdsdata,setRdsData] = useState({'currentuser':'','break_time':''});
    const [errors, setErrors] = useState({});

    const [dataexport, setdataexport] = useState(false);

    useEffect(()=>{
        // getemplist();
        // _getclientslist();
        getmanagerlist();
        
    },[]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'manager'){
            // console.log("manager canged");
            //  console.log(value);
            setmanger(value); 
            setFormData((prevData) => ({
                ...prevData,
                manager: value,
                managername: name,
              }));
            _getemplist({managerid:value}); 
        } 
         
      };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        if (formData.fromdate == '') {
          newErrors.fromdate = 'From date is required';
          valid = false;
        }

        if (formData.todate == '') {
            newErrors.todate = 'To date is required';
            valid = false;
        }
        
        if (formData.manager == '') {
            newErrors.manager = 'Manager is required';
            valid = false;
        }

        // if (formData.managername == '') {
        //     newErrors.managername = 'Budgethours name is required';
        //     valid = false;
        // }

        // if (formData.employee == '') {
        //     newErrors.employee = 'Budgethours name is required';
        //     valid = false;
        // }

        setErrors(newErrors);

       return valid; 
    }  

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
       
        // console.log(formData);  
        let rdsobj =  {
            emp_id: formData.employee,
            fromdate: formatterhelper.dateformatter({date:formData.fromdate}),
            todate: formatterhelper.dateformatter({date:formData.todate}),
            manager_id:formData.manager,     
        }  
       //console.log(rdsobj);
       getrdsreports(rdsobj)
        // getreports(reportobj);
      };

    function deleterds(obj){
        timesheetreportService.deleterds(obj.id).then((response)=>{
             if(response.status == 200){
                  toast.current.show({severity:'success', summary: "Rds", detail:`${response.data.data} `, life: 3000}); 
                  let rdsobj =  {
                        emp_id: formData.employee,
                        fromdate: formatterhelper.dateformatter({date:formData.fromdate}),
                        todate: formatterhelper.dateformatter({date:formData.todate}),
                        manager_id:formData.manager,     
                    } 
                  getrdsreports(rdsobj);
             }else{
                  toast.current.show({severity:'error', summary: "Rds", detail:`${response.data.data} `, life: 3000}); 
             }
        }).catch((error)=>{
             toast.current.show({severity:'error', summary: "Rds", detail:`Error`, life: 3000}); 
        }); 
    }  

    function getrdsreports(reportobj){  
        let emparr = [];
        setloaded(false);
        timesheetreportService.rdsshow_report({obj:reportobj})
        .then((response)=>{
            if(response.status == 200){
                response.data.data.alldata.forEach((value,index) =>{
                    emparr.push((<tr>
                        <td>{value.empname}</td>
                        <td>{value.date_time}</td>
                        <td>{value.new_logontime}</td>
                        <td>{value.new_logofftime}</td>
                        <td>{value.lontime_formated}</td>
                        <td>{value.workingtime_minutes}</td>
                        <td>{value.break_time}</td>
                        <td>{value.total_time}</td>
                        {userdata.roletype == 'admin' ? (<td><button className='btn btn-danger' onClick={()=>{deleterds(value)}}>Del</button></td>) : (<></>)}
                    </tr>));
                }); 
                setDatacomp(emparr);
                setDatastate(true);
                setloaded(true);
                setUser(response.data.data.currentuser);
                setBreaktime(response.data.data.break_time);
                setRdsData(response.data.data);
            }else{
                setDatacomp([]);  
                setDatastate(false);
                setloaded(true);
                 toast.current.show({ severity: 'error', summary: 'RDS Report', detail: response.data.data, life: 3000 });
            }
        }).catch((error)=>{
            console.log(error);
            setDatacomp([]);  
            setDatastate(false);
        });
    }  

    function getmanagerlist(){
        let emparr = [];
        timesheetreportService.getmangrlist().then((response)=>{
           console.log('get manager list');
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setmanagercomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getemplist({managerid}){
        // let managerid = 1;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
            console.log(response);
            response.data.data.forEach((value,index) =>{
                emparr.push((<option value={value.id}>{value.name}</option>));
            });
            setempcomp(emparr);
         }).catch((error)=>{
 
         });    
    }

    function exporttoexcelrdsreport(){
        setdataexport(true);
        let rdsobj =  {
            emp_id: formData.employee,
            fromdate: formatterhelper.dateformatter({date:formData.fromdate}),
            todate: formatterhelper.dateformatter({date:formData.todate}),
            manager_id:formData.manager,     
        } 

        timesheetreportService.export_rds_report({obj:rdsobj}).then((response)=>{
            if(response.status == 200){
                 exporttoexcel(response.data.data.alldata);
                 setdataexport(false);
             }else{
                 toast.current.show({ severity: 'error', summary: 'RDS Report', detail: response.data.data, life: 3000 });
                 setdataexport(false);

             }
        }).catch((error)=>{
            console.log(error);
            setdataexport(false);
        });
    }


    function exporttoexcel(data){
        // dataExporthelper.exportFromhtml({id:'rdsreportid'}); 
        dataExporthelper.exportToExcel(data,{filename:'rds_Reportsexcel_from:'+formData.fromdate});
    }

    return (
        <>
            <Toast ref={toast}/>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>From date</label>
                        <Calendar value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>To date</label>
                        <Calendar value={formData.todate} name="todate" onChange={handleChange} className='calender-custom-style' />
                        {errors.todate && <span className='error'>{errors.todate}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Manager</label>
                        <select className='form-control' name="manager" value={formData.manager} onChange={handleChange}>
                            <option value=''>Select Manager</option>
                            <option value='ALL'>ALL</option>
                            {managerscomp}
                        </select>
                        {errors.manager && <span className='error'>{errors.manager}</span>}
                    </div> 

                    <div className="col-md-2">
                        <label className='pull-left'>Select Employee</label>
                        <select className='form-control' name="employee" value={formData.employee} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {empcomp}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 

                            {dataexport ?  <Button type='button' stype="button" label="Exporting ..." severity="info" onClick={()=> {}} rounded className='custom-btn-style' />:  <Button type='button' stype="button" label="Export" severity="info" onClick={()=> exporttoexcelrdsreport()} rounded className='custom-btn-style' />}
                           
                        </div>

                    </div>
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
                {/* <div className='row'>
                    <div className='pagination-style'>
                        <nav aria-label="Page navigation example">
                            <ul class="pagination">
                                <li class="page-item"><a class="page-link" href="#">Prev</a></li>
                                <li class="page-item"><a class="page-link" href="#">1</a></li>
                                <li class="page-item"><a class="page-link" href="#">2</a></li>
                                <li class="page-item"><a class="page-link" href="#">3</a></li>
                                <li class="page-item"><a class="page-link" href="#">Next</a></li>
                            </ul>
                            </nav>
                    </div>
                </div> */}
                <div className='row'>
                   <div className='col-md-8'>
                    { !isloaded ? loader.Loadermd() : dataavail ?

                    (<table class="table table-bordered" id="rdsreportid">
                        <thead>
                            <tr>
                                <th scope="col">Employee Name</th>
                                <th scope="col">Date</th>
                                <th scope="col">Log in time</th>
                                <th scope="col">Log off time</th>
                                <th scope="col">Work</th>
                                <th scope="col">Work (Min)</th>
                                <th scope="col">Break</th>
                                <th scope="col">Total</th>
                                {userdata.roletype == 'admin' ? (<th scope="col">Action</th>) : (<></>)}
                                
                            </tr>
                        </thead>
                        <tbody>
                            {datacomp}
                        </tbody>
                    </table>) : (<p>No data Found</p>)} 
                    </div>
                    <div className='col-md-4'>
                    <div class="rds_detail_container">
                        <div class="row">
                            <div class="col-md-12">
                            
                                <h2>{rdsdata.currentuser}</h2>
                                        
                            </div> 
                            <div class="col-md-6">
                                <span>Log in Time : </span> <span>{rdsdata.new_logontime}</span>
                            </div>
                            <div class="col-md-6">
                                <span>Log off Time : </span> <span>{rdsdata.new_logofftime}</span>
                            </div>
                            
                            <div class="col-md-12">
                                <br/>
                                <div>
                                <span>Reporting Manager : </span> <span>{formData.managername}</span>
                                </div>
                            </div>
                        </div>

                        <br/>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="rds_detail_style"  >
                                    <span>{rdsdata.logonn}</span>
                                </div>
                                <p style={{textalign: 'center'}}>Work</p>
                            </div>

                            <div class="col-md-4">
                                <div class="rds_detail_style">
                                    <span>{rdsdata.break_time}</span>
                                </div>
                                <p style={{textalign: 'center'}}>Break</p>
                            </div>

                            <div class="col-md-4">
                                <div class="rds_detail_style">
                                    <span>{rdsdata.logonn}</span>
                                </div> 
                                <p style={{textalign: 'center'}}>Timesheet <br/> Hours</p>
                            </div>                    
                        </div>
                    </div>
                    </div>
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Rdsreports;